var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3334 13.3333V5.33333C24.3334 5.14923 24.1841 5 24 5H8.00002C7.81592 5 7.66669 5.14923 7.66669 5.33333V13.3333C7.66669 13.8856 7.21897 14.3333 6.66669 14.3333C6.1144 14.3333 5.66669 13.8856 5.66669 13.3333V5.33333C5.66669 4.04468 6.71133 3 8.00002 3H24C25.2887 3 26.3334 4.04468 26.3334 5.33333V13.3333C26.3334 13.8856 25.8856 14.3333 25.3334 14.3333C24.7811 14.3333 24.3334 13.8856 24.3334 13.3333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 14.6666C27 14.4825 26.8508 14.3333 26.6667 14.3333H5.33333C5.14924 14.3333 5 14.4825 5 14.6666V26.6666C5 26.8507 5.14924 26.9999 5.33333 26.9999H26.6667C26.8508 26.9999 27 26.8507 27 26.6666V14.6666ZM29 26.6666C29 27.9553 27.9553 28.9999 26.6667 28.9999H5.33333C4.04467 28.9999 3 27.9553 3 26.6666V14.6666C3 13.3779 4.04467 12.3333 5.33333 12.3333H26.6667C27.9553 12.3333 29 13.3779 29 14.6666V26.6666Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 21.6667L23.4357 21.672C23.9399 21.7233 24.3333 22.149 24.3333 22.6667V28.0001C24.3333 28.5524 23.8856 29.0001 23.3333 29.0001H13.3333C12.781 29.0001 12.3333 28.5524 12.3333 28.0001V22.6667L12.3385 22.5643C12.3898 22.0602 12.8156 21.6667 13.3333 21.6667H23.3333ZM14.3333 27.0001H22.3333V23.6667H14.3333V27.0001Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.3333C10.5523 16.3333 11 16.781 11 17.3333C11 17.8855 10.5523 18.3333 10 18.3333H8C7.44772 18.3333 7 17.8855 7 17.3333C7 16.781 7.44772 16.3333 8 16.3333H10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachine);
export default __webpack_public_path__ + "static/media/machine.2165a32fdfb753dd1b374c79053c5623.svg";
export { ForwardRef as ReactComponent };